import './Textarea.scss';
import Component from './Textarea.js';
export default Component;
